import { postJson, withDone } from '@rad/utility/http';
export const subscribe = (req) => withDone(postJson('/api/subscribe', req))();
